exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MapContextMenu {\n  position: absolute;\n  background: #fff;\n  z-index: 1500;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  line-height: 24px;\n  padding: 3px 0;\n}\n\n.MapContextMenu div {\n  padding: 0 10px;\n}\n\n.MapContextMenu div:hover {\n  background: #eee;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/map/PluginContextMenu.css
// module id = 1245
// module chunks = 1